import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ConfirmPhoneVerificationProblemType as SchemaConfirmPhoneVerificationProblemType } from '../schemas/ConfirmPhoneVerificationProblemType';
import { type ConfirmPhoneVerificationRequest as SchemaConfirmPhoneVerificationRequest } from '../schemas/ConfirmPhoneVerificationRequest';
import { type Problem as SchemaProblem } from '../schemas/Problem';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Verifies the phone number using the verification code sent to the user
 * @summary Confirm phone verification
 */
export const ConfirmPhoneVerificationContentType = 'application/json' as const;
export type ConfirmPhoneVerificationRequest = SchemaConfirmPhoneVerificationRequest;
export type ConfirmPhoneVerificationResponses = LinkCommonErrorResponses & {
    /**
     * @description Bad request
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaConfirmPhoneVerificationProblemType;
        };
    };
};
export type ConfirmPhoneVerificationResponseSuccess = undefined;
export type ConfirmPhoneVerificationSearchParams = {
    signature: string;
};
export type ConfirmPhoneVerificationPathParameters = {
    store_slug: string;
    order_id: string;
};
export const ConfirmPhoneVerificationUrl = '/{store_slug}/orders/{order_id}/phone/verification/confirm' as const;
export const ConfirmPhoneVerificationMethod = 'POST' as const;
export const getConfirmPhoneVerificationUrl = (params: ConfirmPhoneVerificationPathParameters) =>
    ConfirmPhoneVerificationUrl.replace(/\{(\w+)\}/g, (_match, param: keyof ConfirmPhoneVerificationPathParameters) =>
        String(params[param])
    );
